import { TriggerPayloadConfiguration } from './trigger-payload-configuration';

export class EnrolmentDisqualifiedTriggerPayloadConfiguration extends TriggerPayloadConfiguration {
	public constructor() {
		super(true, true, false, false);
	}
}
